import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { LocationsApi } from '../../shared/api/locations.api';
import {
  LocationActionTypes,
  LocationAddModalConfirmed,
  LocationApiLocationAdded,
  LocationApiLocationDeleted,
  LocationEffectNavigatedBack,
  LocationHeaderLocationDeleted,
} from './locations.actions';

@Injectable()
export class LocationEffects {
  private readonly router = inject(Router);
  private readonly actions$ = inject(Actions);
  private readonly locationApi = inject(LocationsApi);

  addLocationEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(LocationActionTypes.LOCATION_ADD_MODAL_CONFIRMED),
      switchMap((action: LocationAddModalConfirmed) => this.locationApi.addLocation(action.payload)),
      map((location) => new LocationApiLocationAdded(location))
    );
  });

  deleteLocationEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(LocationActionTypes.LOCATION_HEADER_LOCATION_DELETED),
      switchMap((action: LocationHeaderLocationDeleted) =>
        this.locationApi.deleteLocation(action.payload).pipe(map(() => action))
      ),
      map((action: LocationHeaderLocationDeleted) => new LocationApiLocationDeleted(action.payload))
    );
  });

  deleteLocationNavigateEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(LocationActionTypes.LOCATION_HEADER_LOCATION_DELETED),
      switchMap(() => this.router.navigate(['./'])),
      map(() => new LocationEffectNavigatedBack())
    );
  });
}
